
import { mapState } from 'vuex';
import { generateCategoryUrl, getAllActiveCategories } from '@/plugins/helpers/catalog';
import { productGroupTypes } from '@/plugins/enums/product';
import Product from '@/components/catalog/product';
import Breadcrumbs from '@/components/elements/Breadcrumbs';
import pageMeta from '~/mixins/pageMeta';

export default {
  name: 'ProductPage',
  components: {
    Product,
    Breadcrumbs,
  },
  mixins: [pageMeta],
  layout: 'hiddenSidebar',
  scrollToTop: true,
  async asyncData({ $api, route, error, redirect, store }) {
    try {
      const {
        meta,
        product,
        bundles,
        reviews,
      } = await $api.general.getPage(route.path)

      if (!meta || meta?.status > 400) {
        return error({ statusCode: meta?.status || 404 })
      }

      if (meta?.redirect) {
        return redirect(meta.status, meta.redirect)
      }

      await store.dispatch('product/loadProduct', { product, category: route.params.category });
      await store.dispatch('productReviews/loadReviewsData', {
        items: reviews.reviews,
        range: reviews.reviewsCount,
        rating: reviews.rating,
        page: 1,
      })

      return {
        pageTitle: meta?.title || '',
        pageMetaData: meta?.data || [],
        pageLinks: meta?.links || [],
        bundles,
      };
    } catch (e) {
      return error({ statusCode: 404 })
    }
  },
  computed: {
    ...mapState('product', [ 'product' ]),
    ...mapState('catalog', {
      allCategories: 'allCategories',
    }),
    ...mapState('route', {
      categoryCode: (state) => state.params.category || '',
    }),
    breadcrumbsList() {
      const activeCategories = getAllActiveCategories(this.allCategories, this.categoryCode);
      const crumbs = [
        { name: 'Главная', url: '/' },
        { name: 'Каталог', url: '/catalog' },
        ...activeCategories.map((item) => ({
          ...item,
          url: generateCategoryUrl(productGroupTypes.CATALOG, this.categoryCode, item.code),
        })),
        {
          name: this.product.title,
          url: '',
        },
      ];
      return activeCategories.length ? crumbs : [];
    },
    isProduct() {
      return Object.keys(this.product).length
    },
    pageScripts() {
      return [
        {
          innerHTML: `
            (window["rrApiOnReady"] = window["rrApiOnReady"] || [])
              .push(function () {
                try {
                  rrApi.view(${this.product.id});
                } catch (e) { }
            })
          `,
        },
      ]
    },
  },
  beforeCreate() {
    this.$root.setLayout('hiddenSidebar');
  },
};
